const Component13 = ({ items, handleSelection, selectedCategory, selectedColor }) => {
  if (items.length !== 13) {
    return <div>Questo componente è progettato per 13 elementi!</div>;
  }

  const isOutOfStock = (item) => {
    const v = item?.out_of_stock;
    return v === 1 || v === true || v === "1" || v === "true";
  };

  const isNoneItem = (item) => item?.id === "none";

  const firstColumnItems = items.slice(0, 3);
  const secondColumnItem = items.slice(3, 5);
  const terzaColumnItem = items.slice(5, 8);
  const quartaColumnItem = items.slice(8, 10);
  const quintaColumnItem = items.slice(10, 13);

  const getItemClass = (itemId, item) => {
    const selected = selectedColor === itemId ? "selected-border" : "";
    const disabled = isOutOfStock(item) ? "disabled" : "";
    const noneCls = isNoneItem(item) ? "grid-item-none" : "";
    return `${selected} ${disabled} ${noneCls}`.trim();
  };

  const getItemStyle = (item, height) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "4px",
    height,
    color: "white",
    backgroundImage: `url("${item.bg}")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: item?.id === "none" ? "60% auto" : "cover",
  });

  return (
    <div
      className="row m-0"
      style={{
        gap: "10px",
        width: "100%",
        height: "100%",
      }}
    >
      {/* Prima colonna */}
      <div className="col p-0 d-flex flex-column" style={{ gap: "10px" }}>
        {firstColumnItems.map((item, index) => (
          <div
            key={`first-column-${index}`}
            onClick={() => {
              if (isOutOfStock(item)) return;
              handleSelection(selectedCategory, item.id);
            }}
            className={`grid-item ${getItemClass(item.id, item)}`}
            style={getItemStyle(item, "50%")}
          ></div>
        ))}
      </div>

      {/* Seconda colonna */}
      <div className="col p-0 d-flex flex-column" style={{ gap: "10px" }}>
        {secondColumnItem.map((item, index) => (
          <div
            key={`second-column-${index}`}
            onClick={() => {
              if (isOutOfStock(item)) return;
              handleSelection(selectedCategory, item.id);
            }}
            className={`grid-item ${getItemClass(item.id, item)}`}
            style={getItemStyle(item, "50%")}
          ></div>
        ))}
      </div>

      {/* Terza colonna */}
      <div className="col p-0 d-flex flex-column" style={{ gap: "10px" }}>
        {terzaColumnItem.map((item, index) => (
          <div
            key={`terza-column-${index}`}
            onClick={() => {
              if (isOutOfStock(item)) return;
              handleSelection(selectedCategory, item.id);
            }}
            className={`grid-item ${getItemClass(item.id, item)}`}
            style={getItemStyle(item, "50%")}
          ></div>
        ))}
      </div>

      {/* Quarta colonna */}
      <div className="col p-0 d-flex flex-column" style={{ gap: "10px" }}>
        {quartaColumnItem.map((item, index) => (
          <div
            key={`quarta-column-${index}`}
            onClick={() => {
              if (isOutOfStock(item)) return;
              handleSelection(selectedCategory, item.id);
            }}
            className={`grid-item ${getItemClass(item.id, item)}`}
            style={getItemStyle(item, "50%")}
          ></div>
        ))}
      </div>

      {/* Quinta colonna */}
      <div className="col p-0 d-flex flex-column" style={{ gap: "10px" }}>
        {quintaColumnItem.map((item, index) => (
          <div
            key={`quinta-column-${index}`}
            onClick={() => {
              if (isOutOfStock(item)) return;
              handleSelection(selectedCategory, item.id);
            }}
            className={`grid-item ${getItemClass(item.id, item)}`}
            style={getItemStyle(item, "50%")}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default Component13;
